import type { ReactNode } from 'react';

export function Card({ children }: { children: ReactNode }) {
  return (
    <div className="max-w-120 min-w-10 rounded-xl bg-gray-225 px-6 py-4 text-wrap shadow-sm dark:bg-gray-30">
      {children}
    </div>
  );
}
// border border-gray-195 dark:border-gray-30
